import DroppedPinIcon from "../components/DroppedPinIcon";
import FreeIcon from "../components/FreeIcon";
import Logo from "../components/Logo";
import ShieldElectricIcon from "../components/ShieldElectricIcon";
import Spec from "../components/Spec";
import EventCountdown from "../components/EventCountdown";
import EventDate from "../components/EventDate";
import Hero from "../components/Hero";
import Organizers from "../components/Organizers";
import ImageCarousel from "../components/ImageCarousel";
import VideoSection from "../sections/VideoSection";
import ButtonLink from "../components/ButtonLink";
import eventFormatPhoto from "../assets/spiderman.jpeg";
import post_logo from "../assets/spcs_logo.svg"
import video_image from "../assets/palexpo2.jpg"

//import PlanningSection from "../sections/PlanningSection";
import Agenda from "../components/Agenda";
import ThankYouNote from "../components/ThankYouNote";
import SpeakerSection from "../sections/SpeakerSection";
import speaker_marcel_zumbuehl from "../assets/speakers/marcel-zumbuehl.png";
import Sponsors from "../components/Sponsors";
import harfanglab_logo from "../assets/sponsors/harfanglab.png"
import elastic_logo from "../assets/sponsors/elastic-logo-reverse.svg";
import tenable_logo from "../assets/sponsors/tenable-logo.png";
import vectra_logo from "../assets/sponsors/vectra-logo.png";
import airlock_logo from "../assets/sponsors/airlock-logo.png";
/*
import infomaniak from "../assets/infomaniak.png";
import pwc_outlined_logo from "../assets/pwc_outlined_logo.png";
import hkta_logo from "../assets/hkta_logo.png";
import sentinel_one from "../assets/sponsors/SentinelOne_Logo_white-purple.png";
import fortinet_logo from "../assets/sponsors/fortinet-logo.png";
import elastic_logo from "../assets/sponsors/elastic-logo-reverse.svg";
import cyberreason from "../assets/sponsors/cyberreason-logo.png";
import threatray from "../assets/sponsors/threatray-logo.png";

import speaker_daniel_kuenzli from "../assets/speakers/daniel-kuenzli.png";
import speaker_thomas_cueni from "../assets/speakers/thomas-cueni.jpg";
import speaker_rene_bodmer from "../assets/speakers/rene-bodmer.png";
import speaker_luca_bertolotto_cipriani from "../assets/speakers/luca-bertolotto.png";
import speaker_fabian_gentinetta from "../assets/speakers/fabian_gentinetta.jpeg";
import speaker_martin_de_jongh from "../assets/speakers/MartinDJ_SentinelOne.png";
import speaker_eric_de_bressing from "../assets/speakers/eric-de-bressing.jpeg";
import speaker_patrick_buchholz from "../assets/speakers/patrick-buchholz.jpg";
import speaker_detlev_narr from "../assets/speakers/detlev-narr.png";
import speaker_unknown from "../assets/speakers/unknown_person.jpg";
*/


const eventDate: Date = new Date(2026, 4, 19, 12, 45); // 19 may 2026

export default function LuxEventTab() {
  return (
    <div className="container">
      <ThankYouNote />
      <section>
        <div style={styles.logoContainer}>
          <Logo width="auto" height="102px" />
        </div>
        <EventDate date={eventDate} />
        <Hero
          title="Lux’Hack"
          subtitle="Taking cybersecurity seriously, but not ourselves<br><br>Exciting input presentations and good networking opportunities await you - new in Geneva, Zurich, Lugano and also in Luxembourg. Aimed at Cybersecurity Experts, IT enthusiasts and Students , we offer high quality presentations in a relaxed atmosphere and a Networking Apero in the evening"
          titleStyle={styles.title}
          subtitleStyle={styles.subtitle}
        />
        <div className="specs-container">
          <Spec icon={<DroppedPinIcon />} title="Big Bang, House of Startups" url="https://maps.app.goo.gl/P9bAGfjEs1v4FbPX6"/>
          <Spec icon={<FreeIcon />} title="100% Free" />
          <Spec icon={<ShieldElectricIcon />} title="100% cybersecurity" />
        </div>
        <EventCountdown date={eventDate} />
      </section>
      <section>
        <ButtonLink
          href="https://infomaniak.events/en-ch/shop/hack-event-2026-7JXWQVQSMG/event/1594598/"
          newTab={false}
          style={{ maxWidth: "161px" }}
        >
          Register
        </ButtonLink>
      </section>
      {/*
      <section>
        <AboutTheEvent mapUrl="./palexpo-plan.pdf"/>
      </section>
      */}
      {/*
      <section>
        <EventFormat imageSrc={eventFormatPhoto}/>
      </section>
      */}
      {
      <section>
        <Agenda
          headers={['', '']}
          agenda={[
            { time: "12:45 - 13:15", description1: "Registration and Welcome Coffee" },
            { time: "13:15 - 13:45", description1: "Opening Ceremony" },
            { time: "13:45 - 14:15", description1: "Keynote Speech,  Beyond Cybersecurity [Marcel Zumbühl, CISO of Swiss Post]" },
            { time: "14:15 - 14:45", description1: "Threat Landscape Report" },
            { time: "14:45 - 15:15", description1: "Presentation from Main Sponsor Harfanglab" },
            { time: "15:15 - 15:40", description1: "Networking Break" },
            { time: "15:40 - 17:30", description1: "4 Technical Presentations" },
            { time: "17:30", description1: "Apero and Networking" }
          ]
          }
        ></Agenda>
      </section>
      }
      {/*
      <section>
        {
        <PlanningSection
          title="Details"
          subtitle=""
          displayGrid="grid"
          planning={[
            {
              time: "13:00",
              title: "",
              description: "<h1>Registration & Welcome coffee</h1>",
              index: 0,
            },
            {
              time: "13:30",
              title: "",
              description: "<h1>Welcoming introduction</h1>",
              index: 0,
            },
            {
              time: "",
              title: "Tabletop Exercises: Because real Chaos has no pause button<br><small>Swiss Post Cybersecurity - Greg Divorne </small>",
              description: "We’ll break down the real value of cybersecurity table-tops — no simulations, just sharp insights, common pitfalls, and how to make chaos a little more manageable.",
              index: 1,
            },
            {
              time: "",
              title: "OT Security: Tips & Tricks<br><small>Swiss Post Cybersecurity - Christian Fichera & Raphael Ruf</small>",
              description: "OT and IT are different in many ways, and cybersecurity is certainly one of them. Priorities, vulnerabilities and how to remediate them are all key differences between these two worlds.<br>As a pentester, the way you approach assessing IT and OT environments needs to be different too, and the specific knowledge a tester has in the OT world can make the difference between a successful test and a broken OT device.<br>A demo taken from real life pentesting experience will also show how easy it can be to compromise OT environments.",
              index: 2,
            },
            {
              time: "",
              title: "Goodbye Purple Team, Hello Purple Bots<br><small>Hacknowledge Lux - Patrick Mkhael & Ralph El-Khoury</small>",
              description: "This talk unveils a fully automated, AI-driven purple teaming framework that simulates real-world APT attacks, evaluates detection capabilities, and enhances security defense, all in real-time.",
              index: 3,
            },
            {
              time: "",
              title: "From Pentest to Real Threat: Understanding Threat-Led Penetration Testing (TLPT) <br><small>Hacknowledge Lux - François-Jérôme Daniel</small>",
              description: "Traditional penetration testing often focuses on identifying technical vulnerabilities within a defined scope and time. While valuable, these tests rarely reflect how a real threat actor would target your organization. Threat-Led Penetration Testing (TLPT), on the other hand, is designed to simulate real-world, intelligence-driven attacks, tailored to your sector, critical assets, and threat landscape.",
              index: 4,
            },
            {
              time: "",
              title: "Threat Hunting Basics<br><small>Swiss Post Cybersecurity - Edin Mujkanovic</small>",
              description: "From Intel to Hunts. Threat hunting isn’t new but this session is a practical reminder of the basics. Learn how to use threat intelligence to build hunting hypotheses, assess visibility gaps, and take action when signs of compromise are foundWe will also discuss common challenges MSSPs face when handling CTI and provide a practical example of using CTI use case.",
              index: 5,
            },
            {
              time: "",
              title: "GRC tooling: evolution to AI-tomation<br><small>Hacknowledge Lux - Jean-Didier Zotna</small>",
              description: "Governance, Risk and Compliance Services (GRCS) play more than ever a crucial role in the risk management and regulatory compliance of companies. With the emergence and multiplication of local and international obligations and the constant rationalization of the resources dedicated to it, expectations and challenges keep increasing and related tools must evolve. Indeed, GRCS providers and pure players are organizing and proposing an adaptation of their solutions that incorporate automation and AI. Hacknowledge Lux here offers you a brief vision of this evolution and its new integrated hybrid service offering.",
              index: 6,
            },
            {
              time: "17:00",
              title: "",
              description: "<h1>Apero and Networking</h1>",
              index: 16,
            }
          ]}
        />
        }

      </section>
      */}
      {
      <section>
        <SpeakerSection
          title=""
          subtitle="Attendees will leave feeling more connected to a community of builders and to the future of the evolving world of cybersecurity"
          speakers={[
            {
              firstName: "Marcel",
              lastName: "Zumbühl. CISO of Swiss Post",
              title: "Beyond Cybersecurity",
              description:
                "Cybersecurity today is shaped by speed, digital trust and human behavior rather than by technology alone. This talk explores how resilience, participation and culture turn people into the strongest link in an ever‑changing story centered around customers.",
              image:
                speaker_marcel_zumbuehl,
            }
          ]}
        />
      </section>
      }
      {
      <Sponsors
        style={{ marginTop: "120px" }}
        logos={[
          [harfanglab_logo],
          [elastic_logo, tenable_logo, vectra_logo],
          [airlock_logo]
        ]}
      />
      }
      <section>
        
        <Organizers
          organizers={[
            { src: post_logo, name: "Swiss Post Cybersecurity" }
          ]}
          is_luxembourg={true}
          post_logo={post_logo}
        />
        {/*post_logo*/}
      </section>
{       <ImageCarousel
        images={[
          eventFormatPhoto,
          "/img/21efdf712cf79fbd148856011f58bc6e.jpeg",
          "/img/2205cda10dfebc8d1ca3a5bbf2f8515e.jpeg",
          "/img/a7dc9838a6d79336be95edcbb10943c9.jpeg",
          "/img/c67f653b353385bcc7e424359aa6b3e8.jpeg",
          "/img/d6b45f79c4a62172598e9531d0587924.jpeg"
        ]}
        borderRadius="20px"
        height="284px"
        width="90%"
      /> }
      <section>
        <VideoSection
          video="https://vimeo.com/225843060"
          title="Lux'Hack"
          registerUrl="https://infomaniak.events/en-ch/shop/hack-event-2026-7JXWQVQSMG/event/1594598"
          image={video_image}
        />
      </section>
    </div>
  );
}

const styles = {
  logoContainer: {
    display: "flex",
    justifyContent: "center",
  },
  title: {
    background: "linear-gradient(90deg, #FFF 27.78%, #E1E1E1 100%)",
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontFamily: "Poppins",
    fontSize: `${window.outerWidth < 768 ? "12vw" : "5vw"}`,
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "normal",
    margin: 0,
  },
  subtitle: {
    fontFamily: "Arvo",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal",
    marginTop: "-18px",
    textAlign: "center" as "center",
  },
};
